import { graphql } from 'gatsby'
import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import ProjectModel from '../../datas/models/PortfolioProject'
import asTemplate from '../../root/Template'
import { withTransformer } from '../../utils/GatsbyUtils'
import { chainDecorators, memoized } from '../../utils/ReactUtils'
import { localize } from '../../utils/TranslationUtils'
import { Portfolio, HighlightedText, ArrowLink, SectionUptitle, SectionContainer } from '../../components'
import routes from '../../router/routes'
import Technology from '../../datas/models/Technology'
import Seo from '../../components/Seo'
import SeoModel from '../../datas/models/Seo'
import Navbar from '../../components/Navbar'
import HomeContact from '../Homepage/HomeContact'

import TechnologyContent from './TechnologyContent'
import styles from './styles'
import { transformDomainRoutes } from '../../helpers/RouteHelpers'


const mapSelectors = () => ({
  //
})

const mapActions = dispatch => ({
  //
})

function transformer(data, { domainId, slug }) {
  const { allContentfulDomain, allContentfulTechnology, contentfulProjectTemplate, allContentfulProject } = data

  console.log('allContentfulTechnology', allContentfulTechnology)

  if (contentfulProjectTemplate) {
    return {
      projects: allContentfulProject.edges?.map(({node}) => ProjectModel(node)),
      technologies: allContentfulTechnology?.edges?.map(({ node }) => Technology(node)),
      domains: allContentfulDomain?.edges,
      domain: slug,
      seo: SeoModel({
        ...contentfulProjectTemplate?.seo,
        title: contentfulProjectTemplate?.seo?.title?.replace('%s', slug),
      }),
    }
  }
}

const decorators = [
  asTemplate,
  localize,
  withTransformer(transformer),
  connect(mapSelectors, mapActions),
  memoized,
]

function ProjectsTemplate(props) {
  const { projects, technologies, domains, domain, t, locale, seo, activeRoute } = props
  const routesInfosEnhanced = transformDomainRoutes(domains, locale, activeRoute)

  return (
    <>
      <Seo {...seo} />
      <section
        className="portfolio"
        id="portfolio"
      >
        {domains && domains.length > 0
          && (
          <ArrowLink
            className="link-projects"
            route={routes.home.path}
            label={t('allProjectsTitle')}
            routeParams={{ locale }}
            icon="/images/icons/arrow-left-white.svg"
          />
          )
        }
        <Navbar
          routesInfos={routesInfosEnhanced}
          className="navbar"
        />
        {projects?.length > 0
          && (
          <Portfolio
            locale={locale}
            projects={projects}
            displaySwiperNavigation
          />
          )
        }
      </section>
      {technologies && technologies.length > 0
      && (
      <SectionContainer className="technologies">
        <h2 className="baseline">
          { domain
            && (
            <SectionUptitle
              title={t('ourTechnologies')}
            />
            )
          }
        </h2>
        <TechnologyContent technologies={technologies} />
      </SectionContainer>
      )
      }
      <HomeContact
        title={t('haveAnIdea')}
        contactEmail={t('contactEmail')}
      />
      <style jsx>{styles}</style>
    </>
  )
}

ProjectsTemplate.propTypes = {
  projects: PropTypes.arrayOf(ProjectModel.propTypes),
  technologies: PropTypes.arrayOf(Technology.propTypes),
  domains: PropTypes.arrayOf(PropTypes.string),
  t: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
  seo: SeoModel.propTypes,
  activeRoute: PropTypes.string,
}

ProjectsTemplate.defaultProps = {
  projects: [],
  technologies: [],
  domains: [],
  seo: SeoModel.defaultProps,
  activeRoute: '',
}

ProjectsTemplate = chainDecorators(decorators, ProjectsTemplate)

export default ProjectsTemplate

export const query = graphql`
    query($langKey: String!, $slug: String!) {
        contentfulProjectTemplate {
            ...bbsContentfulProjectTemplate
        }
        allContentfulDomain(filter: { node_locale: { eq: $langKey } }) {
          edges {
            node {
              ...bbsContentfulDomain
            }
          }
        }
        allContentfulTechnology(
          filter: {node_locale: {eq: $langKey}, domain: {elemMatch: {slug: {in: [$slug]}}}, displayOnDomain: { in: true }}
          limit: 6
        ) {
            edges {
                node {
                    slug
                    icon {
                        file {
                            url
                        }
                    }
                    features {
                        title
                        description {
                            description
                        }
                    }
                }
            }
        }
        allContentfulProject(
          filter: {domain: {slug: {in: [$slug]}}, node_locale: {eq: $langKey}}
          sort: {fields: order, order:ASC}
        ) {
          edges {
            node {
              ...bbsContentfulProject
            }
          }
        }
    }
`
